import { ShieldAlert, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '../providers/AuthProvider';

export function ImpersonationBanner() {
  const { impersonatingPartner, stopImpersonation } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (!impersonatingPartner) return null;

  const handleStop = () => {
    stopImpersonation();
    navigate('/super-admin/partners');
  };

  // Pasek NIE pozycjonuje się sam. Do 03.11.2026 miał `sticky top-0 z-[100]`
  // i stał w korzeniu layoutu, poza kolumną treści: na szerokim ekranie leżał
  // na nagłówku paska bocznego (logo, „Program partnerski”), a po przewinięciu
  // przyklejał się w tym samym miejscu co `.topbar` — półprzezroczysty, więc
  // jego tekst, logo i okruszki rysowały się jeden na drugim. Miejsce daje mu
  // layout: wspólny przyklejony nagłówek kolumny treści, wiersz NAD `.topbar`.
  // Własne tło `bg-aurora-bg` pod gradientem `.imp-banner` — treść przewijana
  // pod nagłówkiem nie prześwituje przez pasek.
  return (
    <div className="imp-banner bg-aurora-bg text-aurora-text" data-testid="pasek-podgladu-partnera">
      <ShieldAlert className="w-4 h-4 flex-shrink-0 text-aurora-brand" />
      <span className="truncate min-w-0">
        {t('impersonation.previewMode', 'Tryb podglądu')}:{' '}
        <strong className="text-aurora-brand">{impersonatingPartner.companyName}</strong> —{' '}
        {t('impersonation.viewingAsPartner', 'Przeglądasz panel jako partner')}
      </span>
      <button onClick={handleStop} className="btn btn--danger btn--sm flex-shrink-0 ml-auto">
        <X className="w-3.5 h-3.5" />
        {t('impersonation.exit', 'Zakończ podgląd')}
      </button>
    </div>
  );
}
